import { NgModule } from '@angular/core';
import { Routes, RouterModule, PreloadAllModules } from '@angular/router';
import { AuthGuard } from '@sparro/core/guards/auth/auth.guard';

import { HomeComponent } from './modules/home/home.component';
import { DetailComponent } from './modules/detail/detail.component';
import { ErrorComponent } from './modules/error/error.component';
import { SearchComponent } from './modules/search/search/search.component';
import { JournalCommonComponent } from './modules/journal-common/journal-common/journal-common.component';

const routes: Routes = [
  {
    path: '',
    component: JournalCommonComponent,
    children: [
      {
        path: '',
        loadChildren: () => import('./modules/journal-common/journal-common.module').then(m => m.JournalCommonModule)
      },
    ]
  },
  {
    path: 'edit',
    loadChildren: () => import('./modules/journal-edit/journal-edit.module').then(m => m.JournalEditModule),
    canActivate: [AuthGuard],
    data: { service: 'journals'}
  },
  {
    path: 'error',
    component: ErrorComponent,
    pathMatch: 'full'
  },
  {
    path: ':slug',
    component: DetailComponent
  },
  {
    path: '**',
    redirectTo: 'error',
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    preloadingStrategy: PreloadAllModules
  })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
